import { useState } from "react";
import { ListItem, Typography, Box, Collapse } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SubcategoryLine from "./SubcategoryLine";

export default function SubcategoryBudgetList({
	subcategories,
	type,
	categoryGroupId,
	period,
	categoryGroupName,
	maximalSubBudget,
}) {
	const { t } = useTranslation();

	const [isUnbudgetedExpanded, setIsUnbudgetedExpanded] = useState(false);

	const budgetedSubcategories = subcategories.filter(
		(subcategory) => subcategory.budget > 0,
	);

	const unBudgetedSubcategories = subcategories.filter(
		(subcategory) => subcategory.budget <= 0,
	);
	const unBudgetedSubcategoriesTransactionsSum =
		unBudgetedSubcategories.reduce(
			(sum, subcategory) => sum + subcategory.transactionsSum,
			0,
		);

	const userCurrency = localStorage.getItem("userCurrency");

	const expandStyles = {
		width: "20px",
		verticalAlign: "middle",
		mr: 0.5,
	};

	return (
		<>
			{budgetedSubcategories.map((subcategory) => (
				<SubcategoryLine
					key={subcategory._id}
					subcategory={subcategory}
					type={type}
					categoryGroupId={categoryGroupId}
					period={period}
					categoryGroupName={categoryGroupName}
					maxAmount={maximalSubBudget + subcategory.budget}
				/>
			))}
			<ListItem
				sx={{
					pl: 5,
					py: 0,
					display: "flex",
					justifyContent: "space-between",
					opacity: 0.5,
					fontStyle: "italic",
				}}
			>
				{unBudgetedSubcategories.length !== 0 && (
					<>
						<Box
							onClick={() =>
								setIsUnbudgetedExpanded((prev) => !prev)
							}
							sx={{
								cursor: "pointer",
								display: "flex",
							}}
						>
							{isUnbudgetedExpanded ? (
								<>
									<ExpandLess sx={expandStyles} />
									<span>{t("hideUnbudgeted")}</span>
								</>
							) : (
								<>
									<ExpandMore sx={expandStyles} />
									<span>{t("showUnbudgeted")}</span>
								</>
							)}
						</Box>
						<Box sx={{ display: "flex", mr: 0.5 }}>
							<Typography variant="body1">
								{Math.abs(
									unBudgetedSubcategoriesTransactionsSum,
								)
									.toFixed(2)
									.toLocaleString()}{" "}
								{userCurrency}
							</Typography>
							<Typography
								variant="body1"
								sx={{
									mx: 0.5,
								}}
							>
								{"/"}
							</Typography>
							<Typography variant="body1">
								{Math.abs(0).toFixed(2).toLocaleString()}{" "}
								{userCurrency}
							</Typography>
						</Box>
					</>
				)}
			</ListItem>
			<Collapse in={isUnbudgetedExpanded}>
				{unBudgetedSubcategories.map((subcategory) => (
					<SubcategoryLine
						key={subcategory._id}
						subcategory={subcategory}
						type={type}
						categoryGroupId={categoryGroupId}
						period={period}
						categoryGroupName={categoryGroupName}
						maxAmount={maximalSubBudget + subcategory.budget}
					/>
				))}
			</Collapse>
		</>
	);
}
